var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4606",
    width: "63.596mm",
    height: "41.897mm",
    viewBox: "0 0 63.596 41.897",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-206.55 -141.8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect111-9-6-2-7-4-0",
    d: "m207.74 141.8c-0.66061 0-1.1926 0.62279-1.1926 1.3965v39.104c0 0.7737 0.53196 1.3965 1.1926 1.3965h61.211c0.66061 0 1.1924-0.62279 1.1924-1.3965v-39.104c0-0.7737-0.53175-1.3965-1.1924-1.3965zm0.59607 1.1639h60.019c0.44041 0 0.79491 0.41519 0.79491 0.931v37.707c0 0.51581-0.3545 0.93124-0.79491 0.93124h-60.019c-0.4404 0-0.79489-0.41543-0.79489-0.93124v-37.707c0-0.51581 0.35449-0.931 0.79489-0.931z",
    fill: "#999",
    strokeWidth: 0.9105
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3205",
    transform: "translate(144.87 -73.802)",
    fill: "#ececec"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-1-2-3-3-7-6",
    x: 63.262,
    y: 217.5,
    width: 60.417,
    height: 2.7462,
    rx: 0.59039,
    strokeWidth: 0.6216
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-2-6-7-6-8-3",
    x: 63.262,
    y: 252.86,
    width: 60.417,
    height: 2.7462,
    rx: 0.59039,
    strokeWidth: 0.6216
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-7-1-5-1-4-2",
    x: 63.262,
    y: 220.99,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    strokeWidth: 0.65829
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-5-0-8-9-2-5-0",
    x: 63.262,
    y: 236.94,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    strokeWidth: 0.65829
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-6-9-7-2-9-0-6",
    x: 76.2,
    y: 220.99,
    width: 34.198,
    height: 22.529,
    rx: 0.59622,
    strokeWidth: 1.3395
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-5-2-3-9-2-3-3-1",
    x: 76.2,
    y: 244.38,
    width: 34.166,
    height: 7.6849,
    rx: 0.61268,
    strokeWidth: 0.78195
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-3-6-2-8-1-6-5",
    x: 111.37,
    y: 220.99,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    strokeWidth: 0.65829
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-5-5-0-0-9-9-1-5",
    x: 111.37,
    y: 236.94,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    strokeWidth: 0.65829
  })), /*#__PURE__*/React.createElement("rect", {
    id: "rect2991",
    x: 212.16,
    y: 148.05,
    width: 52.364,
    height: 29.411,
    rx: 1.5,
    fill: "#666",
    strokeWidth: 2.7461
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal);
export default __webpack_public_path__ + "static/media/modal.f5af99e984e5a543758473854e9915db.svg";
export { ForwardRef as ReactComponent };